module.exports = __webpack_public_path__ + "img/tab-ok.41d82a8b.svg";